const withNewCount = (str:string, count:number) => str + (count ? ` (${count})` : '');

export default withNewCount;
